import moment from 'moment';
import { selectUser } from '../../state/user/userSlice';
// // import { selectSessions } from '../../state/chat/chatSlice';
import getSMSFromContact from './getSMSFromContact';

import store from '../../state/store';
import getPartipcantNames from '../contact/getParticipantNames';

const generateSmsObject = ({
  sessionId,
  chipData,
  // numArray,
  // destinationArray,
  // contactArray,
  smsani,
}) => {
  const debug = localStorage.getItem('debugFlag') === 'true';
  const user = selectUser(store.getState());

  const numArray = [smsani];
  const destinationArray = [];
  const contactArray = [];

  chipData.forEach((chip) => {
    // take care of non-contact'd numbers
    numArray.push(getSMSFromContact(chip.contact));

    destinationArray.push(getSMSFromContact(chip.contact));
    contactArray.push(chip.contact);
  });

  numArray.forEach((num, index) => {
    // TODO might need to change this cause of the "1" stuff...
    if (num.length === 10) {
      numArray[index] = `1${num}`;
    }
  });

  destinationArray.forEach((num, index) => {
    // TODO might need to change this cause of the "1" stuff...
    if (num.length === 10) {
      destinationArray[index] = `1${num}`;
    }
  });

  if (debug) console.debug('this is sessionId: ', sessionId);
  if (debug) console.debug('this is chipData: ', chipData);
  if (debug) console.debug('this is numArray: ', numArray);
  if (debug) console.debug('this is destinationArray: ', destinationArray);
  if (debug) console.debug('this is contactArray: ', contactArray);

  const smsObject = {};

  const [firstContact] = contactArray;
  smsObject.contact = firstContact;

  smsObject.contactArr = contactArray;

  smsObject.domain = user.domain;

  smsObject.id = sessionId;

  smsObject.lastMessage = '';
  smsObject.lastSender = '';
  smsObject.lastStatus = 'read';
  smsObject.lastTimestamp = moment.utc().format('YYYY-MM-DD HH:mm:ss');
  smsObject.muted = 'no';
  smsObject.numPart = chipData.length;
  smsObject.partNames = getPartipcantNames(contactArray);
  smsObject.remote = destinationArray.join(',');
  smsObject.session_name = '';
  smsObject.smsani = smsani;
  smsObject.startTimestamp = null;
  smsObject.term_queue = null;
  smsObject.queue_status = null;
  smsObject.queue_session_id = null;

  return smsObject;
};

export default generateSmsObject;
